







import Vue from 'vue'

export default Vue.extend({
  name: 'InfoColumnHeader',
  props: {
    label: {
      type: String,
      required: true
    }
  }
})
